import { Pipe, PipeTransform } from '@angular/core';
import { trim } from 'lodash-es';

@Pipe({
  name: 'trim',
  standalone: true,
})
export class TrimPipe implements PipeTransform {
  transform(value: string, chars?: string | undefined): string {
    return trim(value, chars);
  }
}
